<template>
  <div class="display">
    <div class="f-tar">
      <Button @click="$emit('changeOpen')" style="margin-right:10px;">Back</Button>
      <Button @click="$emit('changeOpen2')">Edit</Button>
    </div>
    <div v-if="commitInfo">
      <div class="item">
        <div class="item-l">Submission time：</div>
        <div class="item-r">{{ commitInfo.changeTime | moment("YYYY/MM/DD HH:mm:ss")}}</div>
      </div>
      <div class="item">
        <div class="item-l">Review status：</div>
        <div class="item-r">
          <span v-if="commitInfo.status === 0">Has yet to review</span>
          <span v-if="commitInfo.status === 1">审核通过</span>
          <span v-if="commitInfo.status === -1">审核未通过</span> 
        </div>
      </div>
      <div class="item">
        <div class="item-l">Operation status：</div>
        <div class="item-r">Pending</div>
      </div>
      <div class="item">
        <div class="item-l">Company name：</div>
        <!-- <div
          class="item-r"
          :class="{editMode:  (commitInfo.name && company.name !== commitInfo.name)}"
        >{{ commitInfo.name || 'N/A'}}</div> -->
        <div
          class="item-r"
        >{{ company.name }}</div>
      </div>
      <div class="item">
        <div class="item-l">Company name abbreviation：</div>
        <div
          class="item-r"
          :class="{editMode: (commitInfo.shortName && company.shortName !== commitInfo.shortName)}"
        >{{ commitInfo.shortName || 'N/A' }}</div>
      </div>
      <!-- <div class="item">
        <div class="item-l">公司英文名：</div>
        <div
          class="item-r"
          :class="{editMode: (commitInfo.nameEn && company.nameEn !== commitInfo.nameEn)}"
        >{{ commitInfo.nameEn || 'N/A'}}</div>
      </div> -->
      <!-- <div class="item">
        <div class="item-l">公司英文简称：</div>
        <div
          class="item-r"
          :class="{editMode: (commitInfo.shortNameEn && company.shortNameEn !== commitInfo.shortNameEn)}"
        >{{ commitInfo.shortNameEn || 'N/A'}}</div>
      </div> -->
      <div class="item">
        <div class="item-l">Type of enterprise：</div>
        <div
          class="item-r"
          :class="{editMode: (commitInfo.industry && company.industry !== commitInfo.industry)}"
        >{{ commitInfo.industry || 'N/A'}}</div>
      </div>
      <div class="item">
        <div class="item-l">Staff size：</div>
        <div
          class="item-r"
          :class="{editMode: (commitInfo.scale && company.scale !== commitInfo.scale)}"
        >{{ commitInfo.scale || 'N/A'}}</div>
      </div>
      <div class="item">
        <div class="item-l">Annual sales：</div>
        <div
          class="item-r"
          :class="{editMode: (commitInfo.annualSales && company.annualSales !== commitInfo.annualSales)}"
        >{{ commitInfo.annualSales || 'N/A'}}</div>
      </div>
      <div class="item">
        <div class="item-l">Social Unified Credit Code：</div>
        <div
          class="item-r"
          :class="{editMode: (commitInfo.creditCode && company.creditCode !== commitInfo.creditCode)}"
        >{{commitInfo.creditCode || 'N/A'}}</div>
      </div>
      <div class="item">
        <div class="item-l">Country and region：</div>
        <div
          class="item-r"
          :class="{editMode: (commitInfo.country && company.country !== commitInfo.country)}"
        >{{commitInfo.country || 'N/A'}}</div>
      </div>
      <div class="item">
        <div class="item-l">Province/State：</div>
        <div class="item-r" :class="{editMode: cityBool}" v-if="commitInfo.province">
          <span v-if="commitInfo.province">{{commitInfo.province + ','}}</span>
          <span v-if="commitInfo.city">{{commitInfo.city + ','}}</span>
          <span v-if="commitInfo.county">{{commitInfo.county}}</span> 
        </div>
        <div class="item-r" v-else>N/A</div>
      </div>
      <div class="item">
        <div class="item-l">Address：</div>
        <div
          class="item-r"
          :class="{editMode: (commitInfo.address && company.address !== commitInfo.address)}"
        >{{commitInfo.address || 'N/A'}}</div>
      </div>
      <div class="item">
        <div class="item-l">Type of corporate assets：</div>
        <div
          class="item-r"
          :class="{editMode: (commitInfo.businessType && company.businessType !== commitInfo.businessType)}"
        >{{commitInfo.businessType || 'N/A'}}</div>
      </div>
      <div class="item">
        <div class="item-l">Type of business：</div>
        <div
          class="item-r"
          :class="{editMode: (commitInfo.nature && company.nature !== commitInfo.nature)}"
        >{{commitInfo.nature || 'N/A'}}</div>
      </div>

      <div class="item">
        <div class="item-l">Logo：</div>

        <div class="item-r">
          <div v-if="commitInfo.logo" class="logo-example">
            <div
              class="my-upload-list"
              style="width: 150px;height: 150px;line-height:150px;border: 1px solid #bfbfbf;"
              :class="{edit: (commitInfo.logo && company.logo !== commitInfo.logo)}"
            >
              <img :src="commitInfo.logo" style="width: 150px;height: 150px;" />
            </div>
            <div class="logo-example-box">
              <div class="logo-example-item z-large-s">
                <img :src="commitInfo.logo" />
                <p>Picture size：200*200px</p>
              </div>
              <div class="logo-example-item z-large-m">
                <img :src="commitInfo.logo" />
                <p>Picture size：120*120px</p>
              </div>
              <div class="logo-example-item z-large-l">
                <img :src="commitInfo.logo" />
                <p>Picture size：30*30px</p>
              </div>
            </div>
          </div>
          <div v-else>N/A</div>
        </div>
      </div>

      <div class="item">
        <div class="item-l">Business license：</div>
        <div class="item-r">
          <div v-if="commitInfo.businessLicenses" class="logo-example">
            <div
              class="my-upload-list"
              style="width: 150px;height: 200px;line-height:150px;border: 1px solid #bfbfbf;"
              :class="{edit: (commitInfo.businessLicenses && company.businessLicenses !== commitInfo.businessLicenses)}"
            >
              <img :src="commitInfo.businessLicenses" style="width: 100%;height: 100%;" />
            </div>
          </div>
          <div v-else>N/A</div>
        </div>
      </div>
      <div class="item">
        <div class="item-l">Company details：</div>
        <div class="item-r">
          <customComponentCommonDisplay
            v-model="Introduction"
            :type="commonType"
            @change="changModal"
          ></customComponentCommonDisplay>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import customComponentCommonDisplay from "@components/En/custom-component/custom-component-common-display.vue";
export default {
  name: "company-info-basic-display",
  data() {
    return {
      commonType: 2,
      Introduction: [],
      commitInfo: null // 公司信息提交记录
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      joinInfo: "loginModule/getJoinInfo"
    }),
    cityBool() {
      let bool = false;
      if (this.commitInfo && this.company) {
        const cityStr =
          this.commitInfo.province +
          this.commitInfo.city +
          this.commitInfo.county;
        const cityStr2 =
          this.company.province + this.company.city + this.company.county;
        if (cityStr !== cityStr2) {
          bool = true;
        }
      }
      return bool;
    }
  },
  components: {
    customComponentCommonDisplay
  },
  created() {
    this.getCommitInfo();
  },
  methods: {
    ...mapActions({
      transformCustomData: "customComponentModule/transformCustomData",
      getCompanyDownList: "companyModule/getCompanyDownList"
    }),
    async getCommitInfo() {
      this.commitInfo = await this.getCompanyDownList(this.joinInfo.joinId);
      if (
        this.commitInfo.introduction &&
        this.commitInfo.introduction.indexOf("[") !== -1
      ) {
        this.Introduction = await this.transformCustomData(
          JSON.parse(this.commitInfo.introduction)
        );
      }
      console.log("this.commitInfo", this.commitInfo);
    },
    changModal($event) {
      this.Introduction = $event;
    }
  }
};
</script>

<style scoped lang="scss">
.display {
  padding: 20px 40px 40px;
  font-size: 14px;
  background: #fff;
  margin: 30px;
  color: #333;
  min-width: 800px;
  mim-height: 500px;
  .item {
    display: flex;
    margin-bottom: 18px;
    &-l {
      width: 210px;
      text-align: right;
    }
    &-r {
      flex: 1;
    }
  }
}
.logo-example {
  display: flex;
  &-box {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
  }
  &-item {
    display: flex;
    width: 100%;
    p {
      font-size: 12px;
      color: #808080;
      padding-left: 10px;
    }
    &.z-large-s {
      img {
        width: 40px;
        height: 40px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 40px;
      }
    }
    &.z-large-m {
      img {
        width: 30px;
        height: 30px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 30px;
      }
    }
    &.z-large-l {
      img {
        width: 20px;
        height: 20px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 20px;
      }
    }
  }
}
.editMode {
  color: red !important;
}
.edit {
  border-color: red !important;
}
</style>
